<div fxFlexFill fxLayout="column">
  <mat-toolbar class="mat-elevation-z3" style="z-index: 2; font-weight: 400; font-size: 22px; background-color: #fff;">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <img style="margin-left: 8px; height: 30px;" src="assets/qlogo.png" />
      <span fxFlex style="margin-left: 8px;">Declined Operations</span>
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="content-container">
    <div class="main-container">
      <div class="filters-container">
        <div class="filters-container-header">
          <h2>
            Filters
          </h2>
          <span class="reset-button" (click)="declinedOpsFilterForm.setValue(defaultDeclinedOpsFormModel)">Reset</span>
        </div>

        <div class="filters-container-form">
          <form #filterFormRef class="filter-form" [formGroup]="declinedOpsFilterForm"
            (ngSubmit)="getDeclinedOpsReportResults(declinedOpsFilterForm.value)"
            *ngIf="declinedOpsDropdowns$ | async as declinedOpsDropdowns">
            <div class="form-filters-container">
              <div class="form-field">
                <mat-form-field>
                  <input matInput autocomplete="off" placeholder="Customer Name" name="search"
                    formControlName="search" />
                  <!-- <mat-error *ngIf="declinedOpsFilterForm.get('workOrderId').invalid">
                    {{ getErrorMessage('workOrderId') }}
                  </mat-error> -->
                </mat-form-field>
              </div>

              <div class="form-field">
                <mat-form-field>
                  <mat-select placeholder="Service Advisor" name="serviceAdvisor" formControlName="serviceAdvisorId">
                    <mat-option *ngFor="let serviceAdvisor of declinedOpsDropdowns.serviceAdvisors"
                      [value]="serviceAdvisor.associateId">
                      {{ serviceAdvisor?.embedded?.associate?.firstName }}
                      {{ serviceAdvisor?.embedded?.associate?.lastName }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="form-field">
                <mat-form-field>
                  <mat-select placeholder="Service Category" name="serviceGroupCategory"
                    formControlName="serviceGroupCategory">
                    <mat-option *ngFor="
                        let serviceGroupCategory of declinedOpsDropdowns.serviceGroupCategories | orderBy: 'description'
                      " [value]="serviceGroupCategory.description">
                      {{ serviceGroupCategory.description }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="form-field">
                <mat-form-field>
                  <mat-select placeholder="Declined Reason" name="reason" formControlName="reason">
                    <mat-option *ngFor="let declinedReason of declinedOpsDropdowns.declinedReasons"
                      [value]="declinedReason.reason">
                      {{ declinedReason.reason }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="form-field">
                <mat-form-field>
                  <input matInput autocomplete="off" [matDatepicker]="dateOpenedFromPicker"
                    placeholder="From (Opened) Date" name="dateOpenedFrom" formControlName="dateOpenedFrom" />
                  <mat-datepicker-toggle matSuffix [for]="dateOpenedFromPicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateOpenedFromPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="form-field">
                <mat-form-field>
                  <input matInput autocomplete="off" [matDatepicker]="dateOpenedToPicker" placeholder="To (Opened) Date"
                    name="dateOpenedTo" formControlName="dateOpenedTo" />
                  <mat-datepicker-toggle matSuffix [for]="dateOpenedToPicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateOpenedToPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="form-field">
                <mat-form-field>
                  <input matInput autocomplete="off" placeholder="Work Order Id" name="workOrderId"
                    formControlName="workOrderId" type="number" />
                  <mat-error *ngIf="declinedOpsFilterForm.get('workOrderId').invalid">
                    {{ getErrorMessage('workOrderId') }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-field">
                <mat-form-field>
                  <mat-select placeholder="Stated" name="stated" formControlName="stated">
                    <mat-option [value]="'0'">Implicit</mat-option>
                    <mat-option [value]="'1'">Explicit</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="form-field">
                <mat-form-field>
                  <input matInput autocomplete="off" placeholder="Vehicle Year From" name="vehicleYearFrom"
                    formControlName="vehicleYearFrom" type="number" />
                  <mat-error *ngIf="declinedOpsFilterForm.get('vehicleYearFrom').invalid">
                    {{ getErrorMessage('vehicleYearFrom') }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-field">
                <mat-form-field>
                  <mat-select placeholder="Actioned" name="action" formControlName="action">
                    <mat-option [value]="">All</mat-option>
                    <mat-option [value]="'0'">No</mat-option>
                    <mat-option [value]="'1'">Yes</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="search-button-container">
              <button #searchButton type="submit"
                [ngClass]="{ 'search-button--disabled': declinedOpsFilterForm.invalid }"
                class="search-button mat-elevation-z2">
                <mat-icon [ngClass]="{ 'search-icon--disabled': declinedOpsFilterForm.invalid }" class="search-icon">
                  search
                </mat-icon>
                <span class="search-button-text">Search</span>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="inner-content-container">
        <div class="content-container-header">
          <div class="content-container-header-text">
            <h2>
              Results
            </h2>
            <span class="clear-button" (click)="clearResults()">Clear</span>
          </div>
          <div class="form-field" style="margin-top: 4px;">
            <mat-select placeholder="Sort" name="sort" (selectionChange)="sortChanged(sort, declinedOpsFilterForm)"
              [(ngModel)]="sort">
              <mat-option value="dateOpened">Date Opened - Oldest First</mat-option>
              <mat-option value="-dateOpened">Date Opened - Newest First</mat-option>
            </mat-select>
          </div>
        </div>
        <ng-container
          *ngIf="{ authenticatedUser: authenticatedUser$ | async, dropdowns: declinedOpsDropdowns$ | async } as data">
          <div class="search-results-container" *ngIf="searchResult$ | async as searchResult">
            <div *ngIf="!(isLoading$ | async)">
              <div *ngFor="let group of searchResult.data | groupBy: 'associateId' | pairs">
                <div class="flex flex-row">
                  <h2>{{ group[1][0]?.customerFirstName }} {{ group[1][0]?.customerLastName }}</h2>
                  <button mat-icon-button color="primary" class="bottom-1 ml-3"
                    *ngIf="group[1][0] && !group[1][0].action"
                    (click)="actionAllForCustomer(group[1], data?.dropdowns?.actionTypes)">
                    <mat-icon>done</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" class="bottom-1 ml-3"
                    *ngIf="group[1][0]?.messagePreferenceId == 2"
                    (click)="openCommunicatorTextDialog(data?.dropdowns?.directMessageTemplates,group[1][0], data?.authenticatedUser?.user, group[1])">
                    <img matListAvatar class="pl-2 h-6" src="assets/communicator-logo.png" alt="...">
                  </button>
                  <button mat-icon-button color="primary" class="bottom-1 ml-3"
                    *ngIf="group[1][0]?.messagePreferenceId == 1"
                    (click)="openCommunicatorEmailDialog(group[1][0], data?.authenticatedUser?.user, group[1])">
                    <img matListAvatar class="pl-2 h-6" src="assets/communicator-logo.png" alt="...">
                  </button>
                </div>
                <div class="search-result-card-container">
                  <svc-declined-ops-card *ngFor="let declinedOperation of group[1]"
                    [declinedOperation]="declinedOperation">
                  </svc-declined-ops-card>
                </div>
              </div>
            </div>
            <div class="result-message-container">
              <span class="mat-title" *ngIf="isLoading$ | async; else checkError">Loading...</span>
              <ng-template #checkError>
                <span class="mat-title mat-error" *ngIf="hasError$ | async; else noData">Error retrieving
                  results.</span>
                <ng-template #noData>
                  <span class="mat-title" *ngIf="searchResult?.data?.length === 0 && searchPerformed">No results
                    found.</span>
                </ng-template>
              </ng-template>
            </div>
            <mat-paginator [length]="searchResult.headers?.total" [pageSize]="declinedOpsFilterForm.value.pageSize"
              [pageSizeOptions]="[25, 50, 100]" [pageIndex]="declinedOpsFilterForm.value.page"
              (page)="pageChanged($event, declinedOpsFilterForm)" [showFirstLastButtons]="true">
            </mat-paginator>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>